import { Check, TableRowsOutlined } from '@mui/icons-material';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { Swimlanes } from '../../model/BoardStore';

const OPTIONS: { value: Swimlanes; label: string }[] = [
  { value: 'none', label: 'Без группировки' },
  { value: 'assignee', label: 'Исполнитель' },
  { value: 'parent', label: 'Родительская задача' },
];

type Props = {
  value: Swimlanes;
  onChange: (value: Swimlanes) => void;
};

/** Группировка задач в свимлейны — кнопка над доской с текущим выбором, как в Яндекс Трекере */
const SwimlanesButton: React.FC<Props> = ({ value, onChange }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const current = OPTIONS.find((option) => option.value === value) ?? OPTIONS[0];

  return (
    <>
      <Button
        size="small"
        color="inherit"
        startIcon={<TableRowsOutlined />}
        aria-label={`Группировка задач: ${current.label}`}
        aria-haspopup="menu"
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{ textTransform: 'none', color: 'var(--dark-secondary-color)' }}
      >
        {current.label}
      </Button>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            onClick={() => {
              setAnchor(null);
              onChange(option.value);
            }}
          >
            <ListItemIcon>{option.value === value && <Check fontSize="small" />}</ListItemIcon>
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export { SwimlanesButton };
